import { ChangeDetectorRef, Component } from '@angular/core';
import { GlobalService } from '../../_services/global.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { DatasearchService } from '../../_services/datasearch.service';
import { BusyService } from '../../_services/busy.service';
import { DatePipe, NgFor, NgIf, UpperCasePipe, NgClass } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';

@Component({
  selector: 'app-patent-details',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    DatePipe,
    UpperCasePipe,
    RouterLink,
    FooterComponent,
    NgClass,
    HeaderComponent,
    SidebarComponent,
  ],
  templateUrl: './patent-details.component.html',
  styleUrl: './patent-details.component.scss',
})
export class PatentDetailsComponent {
  transparent = false;
  newsTableName = 'NEWS';
  categoryTableName = 'NEWS_CATEGORY';
  newsDetails: any;
  relatedNews: any = [];
  categoryList: any = [];
  filePath = 'https://adminbackend.chemrobotics.com/uploads/news_images/';
  userDetails: any;
  isLogin = false;
  news_Id: any;
  newsId: any;
  currentUrl: string;
  heading = '';
  toggle_sidebar = false;
  categoryId: string = '';
  categoryName: any = [];
  matchedCategoryName: string = '';
  subcategoryName: string = '';
  databaseId: string = ''; // Store database ID from news details


  constructor(private globalService: GlobalService, private route: ActivatedRoute,
    private busyService: BusyService,
    private datasearch: DatasearchService,
    private router: Router,
    private cdref: ChangeDetectorRef) {
    this.currentUrl = window.location.href; // Get the current URL

  }

  ngOnInit() {
    this.globalService.sendMenuIndex(1);
    this.getNews(this.route.snapshot.params['id']);
  }

  getNews(newsId: any) {
    this.busyService.busy();

    this.datasearch.getNewsDetails(newsId).subscribe(
      (res) => {
        this.busyService.idle();

        const newsData = Array.isArray(res.data) ? res.data[0] : res.data;
        this.newsDetails = newsData;
        console.log("newsDetails", this.newsDetails);

        // ✅ Extract category ID and database ID from database_meta
        this.categoryId = newsData.database_meta?.[0]?.category?._id || newsData.database_meta?.[0]?.category;
        this.databaseId = newsData.database_meta?.[0]?.databaseId || '';
        console.log("categoryId", this.categoryId);
        console.log("databaseId", this.databaseId);

        if (this.categoryId) {
          // Fetch category details AFTER we have the categoryId
          this.getNewsCategoryList();
          // Fetch related news filtered by database ID
          this.getRelatedNews(this.categoryId, newsId);
        } else {
          console.warn('No category found in news data');
        }
      },
      (errorobj) => {
        this.busyService.idle();
        console.error('Failed to fetch news details:', errorobj);
      }
    );
  }

  getNewsSearchCondition(newsId: any) {
    let condition = [];
    let match = {
      _id: newsId,
      news_relatedto: '64f1c55ca59f3a107fba4ac5'
    };
    condition.push({ '$match': match });
    condition.push({
      '$project': {
        _id: 0,
      }
    });
    return condition;
  }

  getRelatedNews(categoryId: any, currentNewsId: any) {
    this.busyService.busy();

    this.datasearch.getNewsByCategory(categoryId).subscribe(
      (res: any) => {
        this.busyService.idle();

        this.categoryName = res.data.category;
        console.log("Category:", this.categoryName);

        const allCategoryNews = res.data.news || [];
        console.log(`📰 Total news in category: ${allCategoryNews.length}`);

        // Filter related news by database ID and exclude current news
        this.relatedNews = allCategoryNews.filter((news: any) => {
          // Exclude current news
          if (news._id === currentNewsId || news.slug === currentNewsId) {
            return false;
          }

          // Filter by database ID if available
          if (this.databaseId && news.database_meta && Array.isArray(news.database_meta)) {
            const hasMatchingDatabase = news.database_meta.some((meta: any) =>
              meta.databaseId === this.databaseId
            );

            if (!hasMatchingDatabase) {
              console.log(`  ⏭️ Skipped related news "${news.title}" (no matching databaseId)`);
            }

            return hasMatchingDatabase;
          }

          // If no database ID to filter by, include the news
          return true;
        }).slice(0, 5);

        console.log(`✅ Filtered related news: ${this.relatedNews.length} items`);
      },
      (errorobj: any) => {
        this.busyService.idle();
        console.error('Error fetching related news:', errorobj);
      }
    );
  }

  getSearchCondition(catId: any, newsId: any) {
    let condition = [];
    let match = {
      _id: {
        $ne: newsId
      },
      news_relatedto: '64f1c55ca59f3a107fba4ac5',
      news_category: catId,
    };
    condition.push({ '$match': match });
    condition.push({
      '$sort': {
        news_date: -1
      }
    });
    condition.push({ '$skip': 0 });
    condition.push({ '$limit': 3 });
    return condition;
  }

  getNewsCategoryList() {
    this.datasearch.getCatSubcatTree(this.categoryId).subscribe(
      (res: any) => {
        const categories = res.data.categories;

        // Find category that matches this.categoryId
        const matchedCategory = categories.find(
          (cat: any) => cat._id === this.categoryId,
        );



        // If found, filter subcategories by database ID
        if (matchedCategory) {
          this.matchedCategoryName = matchedCategory.name || '';

          const allSubcategories = matchedCategory.subcategories || [];

          // Filter subcategories by database ID
          const filteredSubcategories = allSubcategories.filter((subcat: any) => {
            if (subcat.database_meta && subcat.database_meta.databaseId) {
              const databaseIds = Array.isArray(subcat.database_meta.databaseId)
                ? subcat.database_meta.databaseId
                : [subcat.database_meta.databaseId];

              const hasMatchingDatabase = databaseIds.includes(this.databaseId);

              return hasMatchingDatabase;
            }
            console.warn(`  ⚠️ Subcategory "${subcat.name}" has no database_meta`);
            return false;
          });

          this.categoryList = filteredSubcategories;
          this.subcategoryName = filteredSubcategories[0]?.name || '';
        } else {
          this.matchedCategoryName = '';
          this.categoryList = []; // fallback if not found
        }
      },
      (errorobj: any) => {
        console.error('Failed to load category tree:', errorobj);
      }
    );
  }

  getNewsCategoryCondition() {
    let condition = [];
    let match = {
      isActive: true
    };
    condition.push({ '$match': match });
    condition.push({
      '$sort': {
        name: 1
      }
    });
    return condition;
  }

  goToNewsDetail(newsId: any) {
    // Navigate to the new news detail page
    this.router.navigate(['/discovery-updates', newsId]).then(() => {
      // After navigation, fetch the new news details
      this.getNews(newsId);
      this.getNewsCategoryList();
    });
  }
  navigateToCategory(categoryName: string) {
    this.router.navigate(['/news/category', categoryName]);
  }

  redirectToNewsCategorySection() {
    this.router.navigate(['/news_category_section']);
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }

  ngAfterViewInit() {
    this.cdref.detectChanges();
  }

  receiveHeading(event: string) {
    this.heading = event;
    this.cdref.detectChanges();
  }

  receiveSidebarEvent(event: boolean) {
    this.toggle_sidebar = event;
    this.cdref.detectChanges();
  }
}
